
import styled from 'styled-components'
import { motion } from 'framer-motion'

const Animator = ({ bg = "transparent", children, motion }) => {

    return (
        <Wrap $bg={bg} {...motion} >{children}</Wrap>
    )
}

export default Animator

const Wrap = styled(motion.div)`
    background: ${(props) => (props.$bg)};
`
